import { useState } from 'react';
import { AudioSample } from '../../../mocks/scores';

interface SoundCloudPlayerProps {
  sample: AudioSample;
  title: string;
}

function formatTime(secs: number): string {
  const m = Math.floor(secs / 60);
  const s = secs % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}

export default function SoundCloudPlayer({ sample, title }: SoundCloudPlayerProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  const { url, startTime, endTime } = sample;

  const encodedUrl = encodeURIComponent(url);
  const iframeSrc = `https://w.soundcloud.com/player/?url=${encodedUrl}&start_time=${startTime}&auto_play=false&hide_related=true&show_comments=false&show_user=false&show_reposts=false&visual=false&color=%23000000`;

  return (
    <div className="bg-washi rounded-md overflow-hidden">
      {/* Header row */}
      <button
        onClick={() => setIsExpanded((v) => !v)}
        className="w-full flex items-center gap-4 px-4 py-3 hover:bg-sumi/5 transition-colors cursor-pointer"
        aria-label="試聴プレーヤーを開く"
      >
        <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-sumi text-white">
          <i className={`${isExpanded ? 'ri-subtract-line' : 'ri-play-fill'} text-sm`}></i>
        </div>
        <div className="flex-1 min-w-0 text-left">
          <p className="font-sans text-xs text-sumi/50 tracking-wider uppercase">Audio Sample</p>
          <p className="font-sans text-xs text-sumi/40 mt-0.5">
            {formatTime(startTime)} 〜 {formatTime(endTime)}
          </p>
        </div>
        <i className={`ri-arrow-${isExpanded ? 'up' : 'down'}-s-line text-sumi/30 text-sm flex-shrink-0`}></i>
      </button>

      {/* SoundCloud embed */}
      {isExpanded && (
        <div className="px-4 pb-4">
          <iframe
            title={`${title} sample audio`}
            width="100%"
            height="80"
            src={iframeSrc}
            allow="autoplay"
            style={{ border: 0 }}
          />
          <p className="font-sans text-xs text-sumi/30 mt-2 text-right">
            ※ {formatTime(startTime)} 付近から再生されます
          </p>
        </div>
      )}
    </div>
  );
}
